import { isDesktop } from 'react-device-detect';
import { toast } from 'react-toastify';

import { getAccount, switchChain as switchChainWagmi } from '@wagmi/core';

import type { WalletType } from '@api';

// eslint-disable-next-line deprecate/import
import { wagmiConfig, type WagmiConfigChain } from '@shared/common/providers/LegacyWeb3Provider/wagmi';
import { namedWeb3Errors } from '@shared/constants/errors';
import { DEFAULT_TARGET_CHAIN} from '@shared/constants/wallets';
import { normalizeError } from '@shared/helpers/displayErrorToast';
import getChainRequirements from '@shared/helpers/web3/getChainRequirements';
import launchAsyncToast from '@shared/helpers/web3/launchAsyncToast';

/**
 * @deprecated Don't use it, use useSwitchChain instead
 */
export const switchChainUtilDeprecated = async (props: {
  targetChain?: WagmiConfigChain;
  address: string;
  walletType: WalletType;
  requiredSqrAmount?: number | string;
}): Promise<ReturnType<typeof getChainRequirements> | undefined> => {
  const { targetChain = DEFAULT_TARGET_CHAIN, walletType, address, requiredSqrAmount } = props;
  const { chainId } = getAccount(wagmiConfig);
  const chain = wagmiConfig.chains.find((ch) => ch.id === chainId);

  if (chain === undefined) {
    throw new Error(namedWeb3Errors.RECONNECT_REQUEST);
  }

  const requirements = getChainRequirements(targetChain, requiredSqrAmount);

  if (chain.id !== targetChain.id) {
    const toastId = new Date().getTime();

    try {
      await Promise.race([
        switchChainWagmi(wagmiConfig, {
          chainId: targetChain.id,
        }),
        launchAsyncToast({
          walletType,
          address,
          toastId,
          title: 'Waiting for the user to switch the chain...',
          showExtraInfo: !isDesktop,
        }),
      ]);

      toast.dismiss(toastId);

      return await switchChainUtilDeprecated(props);
    } catch (error) {
      toast.dismiss(toastId);

      const normalizedError = normalizeError(error);

      if (normalizedError.message === namedWeb3Errors.RETRY) {
        return switchChainUtilDeprecated(props);
      }

      if (normalizedError.message === requirements.nativeBalance) {
        throw error;
      }

      throw new Error(requirements.chain);
    }
  }

  return requirements;
};
